export default "__VITE_ASSET__DEDfavkE__"